import { api } from "./api";

export interface PatrulhaSessaoLog {
  id: string;
  id_patrulha_sessao: string;
  id_militar: string;
  acao: string;
  data_hora: string;
  militar: {
    id: string;
    nick: string;
    patente: {
      id: string;
      nome: string;
      sigla: string;
    };
  };
}

export interface PatrulhaSessao {
  id: string;
  data_hora_inicio: string;
  data_hora_pausa: string | null;
  data_hora_fim: string | null;
  tempo_pausado_segundos: number;
  status: "aberta" | "pausada" | "fechada";
  logs: PatrulhaSessaoLog[];
}

export const abrirSessao = async (): Promise<PatrulhaSessao> => {
  const response = await api.post("/patrulhas/sessoes/abrir");
  return response.data;
};

export const pausarSessao = async (): Promise<PatrulhaSessao> => {
  const response = await api.patch("/patrulhas/sessoes/pausar");
  return response.data;
};

export const retomarSessao = async (): Promise<PatrulhaSessao> => {
  const response = await api.patch("/patrulhas/sessoes/retomar");
  return response.data;
};

export const finalizarSessao = async (): Promise<PatrulhaSessao> => {
  const response = await api.patch("/patrulhas/sessoes/finalizar");
  return response.data;
};

export const obterSessaoAtiva = async (): Promise<PatrulhaSessao | null> => {
  const response = await api.get("/patrulhas/sessoes/ativa");
  return response.data;
};
